<template>
	<div>
		<h2 class="text-center text-[20px] leading-[28px] font-semibold text-gray-900">
			Here is what changes on Free
		</h2>
		<p class="mt-0.5 text-center text-[14px] leading-[20px] font-normal text-gray-500">
			Please don’t hesitate to
			<router-link
				:to="{ name: 'learning-hub-courses' }"
				class="font-medium text-won-green hover:underline"
			>
				contact us
			</router-link>
			if we can do anything to keep WonsultingAI supporting you in your job search.
		</p>

		<div
			v-if="isLoading"
			class="mt-4 flex justify-center py-6"
		>
			<LoadingIcon
				color="#EB5757"
				margin=""
			/>
		</div>

		<ul
			v-else
			class="mt-4 flex flex-col gap-3 rounded-md bg-won-red-light px-4 py-3"
		>
			<li
				v-for="feature in resolvedFeatures"
				:key="feature.key"
				class="flex items-start gap-2"
			>
				<XCircleIcon class="mt-px size-5 shrink-0 text-won-red" />

				<div>
					<p class="text-[14px] leading-[20px] font-semibold text-gray-900">
						{{ feature.title }}
					</p>
					<p class="text-[14px] leading-[20px] font-normal text-gray-500">
						{{ feature.description }}
					</p>
				</div>
			</li>
		</ul>

		<button
			type="button"
			class="
				mx-auto mt-6 flex h-9 w-full max-w-[320px] items-center justify-center rounded-md
				bg-won-green px-3 text-[16px] leading-[20px] font-medium text-white
				hover:bg-won-green-dark
			"
			@click="emit('keep')"
		>
			Never mind, keep it
		</button>

		<button
			type="button"
			class="
				mx-auto mt-2 flex h-9 w-full max-w-[320px] items-center justify-center rounded-md
				bg-won-red px-3 text-[16px] leading-[20px] font-medium text-white hover:bg-won-red-dark
			"
			@click="emit('cancel')"
		>
			Cancel Subscription
		</button>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { XCircleIcon } from '@heroicons/vue/24/outline';

import LoadingIcon from '../../../../icons/loading-spinner.vue';
import { USAGE_FEATURE_COPY } from './usage-features';

const props = defineProps({
	/**
	 * The usage-summary endpoint's ranked features, as `{ key, count, category }`. Rendered in
	 * the order given — the endpoint already ranked them, most-used first.
	 */
	features: {
		type: Array,
		default: () => [],
	},
	isLoading: {
		type: Boolean,
		default: false,
	},
});

// Neither button does async work: one closes the flow and the other only moves to the next
// step, so there is no submitting state here.
const emit = defineEmits(['keep', 'cancel']);

/**
 * The features paired with their copy. A key this table doesn't know is dropped rather than
 * rendered blank, so adding a feature server-side can only shorten the list, never break it.
 */
const resolvedFeatures = computed(() => props.features
	.filter((feature) => USAGE_FEATURE_COPY[feature.key])
	.map((feature) => ({
		key: feature.key,
		title: USAGE_FEATURE_COPY[feature.key].title,
		description: USAGE_FEATURE_COPY[feature.key].description(feature.count, feature.category),
	})));
</script>
